/**
 * @deprecated Use `my-courses-with-filters` (`LazyMyCoursesWithFilters`) instead.
 * This component is no longer maintained and should not be used in new code.
 */
export { default as MyCoursesWithRules } from './LazyMyCoursesWithRules';
export type { MyCoursesWithRulesProps } from './types';
